import { z } from "zod"
import { ProcessingHandlerType } from "./event-kind"
import { eventSchema } from "./event-registry"
import {
    addLicenseUsagePayloadSchema,
    deliverUserChannelMessagePayloadSchema,
    dispatchStitchPayloadSchema,
    importImagesPayloadSchema,
    liveVideoDelayShutdownPayloadSchema,
} from "./events"

export const eventProcessingPayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.Event),
    event: eventSchema,
})

export type EventProcessingPayload = z.infer<typeof eventProcessingPayloadSchema>

export const processingPayloadSchema = z.discriminatedUnion("type", [
    liveVideoDelayShutdownPayloadSchema,
    importImagesPayloadSchema,
    addLicenseUsagePayloadSchema,
    dispatchStitchPayloadSchema,
    eventProcessingPayloadSchema,
    deliverUserChannelMessagePayloadSchema,
])

export type ProcessingPayload = z.infer<typeof processingPayloadSchema>
